angular.module('picmonicpublic')
    .controller('PricingController', ['$scope', '$state', '$stateParams', '$modal', '$anchorScroll', 'MarketOptionsConfig', 'UserService', 'MarketSelectorModalService', 'SplitTestService', 'splitTest', '$location', 'groupBuy', 'bundleBuy', 'GroupBuyService', 'BundleBuyService', '$cookies', function ($scope, $state, $stateParams, $modal, $anchorScroll, MarketOptionsConfig, UserService, MarketSelectorModalService, SplitTestService, splitTest, $location, groupBuy, bundleBuy, GroupBuyService, BundleBuyService, $cookies) {
        
        $anchorScroll.yOffset = 130;
        $scope.$anchorScroll = $anchorScroll;
        $scope.now = Date.now()/1000;
        
        $scope.slug = $stateParams.slug;
        var market_data = MarketOptionsConfig.getMarketBySlug($stateParams.market);
        $scope.market_data = market_data;
        $scope.market = market_data.slug;
        $scope.$stateParams = $stateParams;
        $scope.palife = $stateParams.palife;
        $scope.UserService = UserService;
        $scope.splitTest = splitTest;
        $scope.fuel_env = window.pls_config.fuel_env;

        if ($scope.palife) {
            var expires = new Date();
            expires.setTime(expires.getTime() + (365*24*60*60*1000));
            $cookies.put('pls_user_palife', 1, {expires: expires});
        }

        if (groupBuy) {
            $scope.market = $scope.slug = groupBuy;

            if (GroupBuyService.group_buy.time_left <= 0) {
                $stateParams.is_group_buy = 0;
            }
        }

        if (bundleBuy) {
            $scope.market = $scope.slug = bundleBuy;

            if (BundleBuyService.bundle_buy.time_left <= 0) {
                $stateParams.is_bundle_buy = 0;
            }
        }

        if ($stateParams.no_market) {
            $modal.open({
                        templateUrl: '/templates/public/modals/pricing-selector.html',
                        windowClass: 'market-selector',
                        controller: ['$scope', '$filter', '$modalInstance', 'MenuService', function ($scope, $filter, $modalInstance, MenuService) {
                            $scope.loading = true;
                            MenuService.navigation.$promise.then(function(){
                                $scope.loading = false;
                                $scope.markets = $filter('filter')(MenuService.navigation.items, {title: 'Pricing'}, true)[0];
                            });
                        }]
                    }).result.then(function(link){
                        var slug = link.split('/').pop();
                        if (slug.indexOf('beta') !== -1 ) {
                            window.location = link;
                            return;
                        }

                        $location.path(link);
                    });
        }
 
        if ($scope.market) {
            userMarket = MarketOptionsConfig.getMarketBySlug($scope.market);
            if (userMarket.id) {
                UserService.setMarketCookies(userMarket.id);
            }
        } else if ($scope.slug === 'beta') {
            window.location = '/pillars/efficient-effective'
        }

        $scope.showMarketSelectorModal = function(market) {
            if (UserService.user.user_id) {
                window.location = '/home?browseOpen';
                return;
            }

            $scope.showRegisterModal();
        };

        $scope.goToURL = function(url) {
            if (typeof atlasEvent !== 'undefined') {
                atlasEvent('click', 'learn_more');
            }

            document.location.href = url;
        };

        $scope.showRegisterModal = function(login) {
            if ($state.current && typeof $state.current.name === 'string' && $state.current.name.indexOf('public.pricing') === 0) {
                atlasEvent('click', 'try it free pricing');
            }

            $modal.open({
                templateUrl: '/templates/modals/register-modal.html',
                windowClass: 'registration-cta-modal full-screen-modal',
                backdropClass: 'modal-body-reduced',
                controller: 'RegisterModalController',
                resolve: {
                    card: function () {
                        return $scope.card ? $scope.card : undefined;
                    },
                    tab: function() {
                        return login ? 'login' : 'register';
                    },
                    redirect: function() {
                        return $scope.card ? '/learn/' + $scope.card.slug : '/find-picmonic' + ($scope.market_data?'?market='+$scope.market_data.slug:'');
                    }
                }
            });
        };
    }]);
